import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getEmployeePerformance } from '../../services/admin/api';
import { ArrowLeft } from 'lucide-react';
import { toast } from 'react-toastify';

const EmployeePerformanceReport = () => {
    const{employeeId} = useParams();
    const navigate = useNavigate();
    const [employeePerformance, setEmployeePerformance] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEmployeePerformance = async () => {
            try{
                const response = await getEmployeePerformance(employeeId);
                setEmployeePerformance(response.data);
            } catch(error){
                toast.error("Failed to fetch employee performance. Please try again.");
            } finally{
                setLoading(false);
            }
        };
        fetchEmployeePerformance();
    },[employeeId]);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div className="admin-employee-table-wrapper">
            <div className="employee-performance-container">
               <button
  type="button"
  className="employee-performance-back-button"
  onClick={() => navigate(-1)}
>
  <ArrowLeft size={18} />
  <span>Back</span>
</button>
                <h2>Employee Performance Report</h2>
                <br/>
                <h3><b>{employeePerformance?.employeeName}</b></h3>

                <div className="performance-summary">
                <div className="performance-card">
                    <h4>Total Cases Handled</h4>
                    <p>{employeePerformance?.totalCasesHandled}</p>
                </div>

                <div className="performance-card">
                    <h4>Accuracy Rate</h4>
                    <p>{employeePerformance?.accuracyRate}</p>
                </div>

                <div className="performance-card">
                    <h4>TAT Compliance</h4>
                    <p>{employeePerformance?.tatCompliance}</p>
                </div>

                <div className="performance-card">
                    <h4>Pending Cases</h4>
                    <p>{employeePerformance?.pendingCases ?? 0}</p>
                </div>
                </div>

                <h3>Pending Candidates</h3>

                <table className="admin-employee-table">
                <thead>
                    <tr>
                    <th>Candidate ID</th>
                    <th>Candidate Name</th>
                    <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    {employeePerformance?.pendingCandidates?.length > 0 ? (
                    employeePerformance.pendingCandidates.map((candidate) => (
                        <tr key={candidate.candidateId}>
                        <td>{candidate.candidateId}</td>
                        <td>{candidate.candidateName || "-"}</td>
                        <td>{candidate.status}</td>
                        </tr>
                    ))
                    ) : (
                    <tr>
                        <td colSpan="3" style={{ textAlign: "center" }}>
                        No pending candidates found.
                        </td>
                    </tr>
                    )}
                </tbody>
                </table>
            </div>
        </div>
    );
};

export default EmployeePerformanceReport;